import { HeadcountMonth, TurnoverMonth } from "models/hr-dashboard";

interface MonthHeaderProps {
    months: (HeadcountMonth | TurnoverMonth)[];
    fiscalYear: number;
    label: string;
    trailing?: string[]; // columns after the 12 months
}

// Two header rows: fiscal quarters (Q1 = Sep–Nov) over the 12 months, then the trailing columns (YTD).
const MonthHeader = ({ months, fiscalYear, label, trailing = ["YTD"] }: MonthHeaderProps) => (
    <thead>
        <tr>
            <th rowSpan={2} className="align-middle">{label}</th>
            {[1, 2, 3, 4].map(q => (
                <th key={q} colSpan={3} className="text-center">Q{q} FY{fiscalYear}</th>
            ))}
            {trailing.map(t => <th key={t} rowSpan={2} className="text-end align-middle">{t}</th>)}
        </tr>
        <tr>
            {months.map(m => (
                <th key={m.key} className="text-end">
                    {m.label}
                    {m.isMtd && <div className="small fw-normal text-muted">Month-to-date</div>}
                </th>
            ))}
        </tr>
    </thead>
);

export default MonthHeader;
